export default (params) => ({
  trigger: {
    name: 'product_specifications.click_all',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'short_specifications',
          'composed_content',
        ],
      },
    },
    event: {
      name: 'select_all',
      params: {
        content: null,
      },
    },
  },
});
